import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { NavBar } from './navbar'
import ButtonGroup from './button-group'

export default class Tab extends React.Component {
  render() {
    return (
      <Wrapper>
        <NavBar { ...this.props } />
        <ButtonGroup { ...this.props } />
      </Wrapper>
    )
  }
}

Tab.propTypes = {
  isFetching: PropTypes.bool,
  isEdit: PropTypes.bool,
}
Tab.defaultProps = {
  isFetching: false,
  isEdit: false,
}

const Wrapper = styled.div`
  background-color: #ffffff ;
  height: 40px ;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, .16);
`



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab-content/lob-submit/tab/index.js